import { unwrapForRead as e } from "./helpers/unwrap-for-read.js";
import { inferDiscriminatorMappingComposition as t } from "./helpers/get-compositions-to-render.js";
import ee from "../shared/ExternalDocs.vue.js";
import n from "../shared/ScreenReader.vue.js";
import { SCHEMA_DYNAMIC_SCOPE_SYMBOL as te, resolveDynamicSchema as r, useDynamicScope as ne } from "./helpers/dynamic-scope.js";
import { isTypeObject as i } from "./helpers/is-type-object.js";
import { isEmptySchemaObject as a } from "./helpers/is-empty-schema-object.js";
import { isOnSchemaTargetPath as re } from "./helpers/is-on-schema-target-path.js";
import { mergeAllOfSchemas as ie } from "./helpers/merge-all-of-schemas.js";
import { partitionAllOfCompositions as ae } from "./helpers/partition-all-of-compositions.js";
import { SCHEMA_ANCESTORS_SYMBOL as o } from "./helpers/schema-cycle.js";
import { SCHEMA_TREE_ROOT_SYMBOL as s, toNodeKey as c, useSchemaExpansion as oe } from "./helpers/schema-expansion.js";
import { handleTreeKeydown as se } from "./helpers/schema-keyboard-nav.js";
import { useLocalization as ce } from "./localization/index.js";
import le from "./SchemaGlyphPuck.vue.js";
import ue from "./SchemaComposition.vue.js";
import de from "./SchemaProperty.vue.js";
import fe from "./SchemaObjectProperties.vue.js";
import { Fragment as l, computed as u, createBlock as d, createCommentVNode as f, createElementBlock as p, createElementVNode as m, createTextVNode as h, createVNode as g, defineComponent as _, inject as v, normalizeClass as y, openBlock as b, provide as x, toDisplayString as S, toRef as pe, unref as C, useId as w, vShow as me, withCtx as he, withDirectives as T } from "vue";
import { resolve as E } from "@scalar/workspace-store/resolve";
import { ScalarMarkdown as D } from "@scalar/components/markdown";
import { pushDynamicScope as O } from "@scalar/workspace-store/helpers/dynamic-ref";
//#region src/schema/Schema.vue?vue&type=script&setup=true&lang.ts
var k = {
	key: 1,
	class: "schema-card-description [.schema-card--level-0:nth-of-type(1)>&]:has-[+.schema-properties]:mb-0! [.schema-card--level-0:nth-of-type(1)>&]:has-[+.schema-properties]:border-b-0! [.schema-card--level-0:nth-of-type(1)>&]:has-[+.schema-properties]:pb-0!"
}, A = {
	key: 2,
	class: "text-c-2 py-1.5"
}, j = {
	key: 0,
	class: "schema-properties w-full! rounded-none! border-0!"
}, M = [
	"id",
	"aria-controls",
	"aria-expanded"
], N = { class: "additional-toggle-label" }, P = ["id", "role"], F = /*@__PURE__*/ _({
	__name: "Schema",
	props: {
		schema: {},
		level: { default: 0 },
		depth: { default: 0 },
		name: {},
		compact: { type: Boolean },
		noncollapsible: {
			type: Boolean,
			default: !1
		},
		hideHeading: { type: Boolean },
		hideDescription: {
			type: Boolean,
			default: !1
		},
		additionalProperties: { type: Boolean },
		additionalPropertyCount: {},
		hideModelNames: {
			type: Boolean,
			default: !1
		},
		discriminator: {},
		breadcrumb: {},
		eventBus: {},
		options: {},
		schemaContext: {},
		compositionPath: {},
		cycleKey: {},
		scrollTargetId: {},
		specificationExtension: {},
		expansion: {}
	},
	setup(_) {
		let { translate: F } = ce(), I = u(() => _.additionalPropertyCount === void 0 ? F("schema.showAdditionalProperties") : F(_.additionalPropertyCount === 1 ? "schema.showOneMoreProperty" : "schema.showMoreProperties", { count: _.additionalPropertyCount })), L = u(() => _.hideModelNames || !!_.options.hideModelNames), R = ne(), z = u(() => e(_.schema)), B = u(() => {
			let e = z.value;
			if (!e || typeof e != "object") return e;
			let t = r(e, R);
			return "$ref" in t ? E.schema(t) : t;
		}), V = z.value ? r(z.value, R) : void 0;
		x(te, V ? O(R, V) : R);
		let H = v(o, void 0), U = u(() => _.cycleKey != null && !!H?.has(_.cycleKey)), W = new Set(H ?? []);
		_.cycleKey != null && W.add(_.cycleKey), x(o, W);
		let ge = u(() => !!_.options.expandAllSchemaProperties && !U.value), _e = u(() => re(c(_.breadcrumb), _.scrollTargetId ?? "")), ve = u(() => _.noncollapsible || ge.value || _e.value), G = u(() => {
			let e = B.value;
			if (_.hideDescription) return null;
			let t = z.value;
			return t?.allOf && t.allOf.length > 0 && _.name === "Request Body" ? ie(t)?.description || null : !e?.description || typeof e.description != "string" || e.enum || !("properties" in e) && !("patternProperties" in e) && !("additionalProperties" in e) && !("allOf" in e) || t?.allOf && ae(t).segments.some((t) => t.kind === "object" && t.schema.description === e.description && ("properties" in t.schema || "patternProperties" in t.schema || "additionalProperties" in t.schema) && !t.schema.enum) ? null : e.description;
		}), K = u(() => z.value && !_.discriminator && i(z.value) ? t(z.value, _.options.document) : null), ye = u(() => !K.value && i(B.value)), q = v(s, !1), J = u(() => _.depth === 0 && !q);
		x(s, !0);
		let be = (e) => {
			J.value && _.options.schemaKeyboardNav && se(e);
		}, Y = _.expansion ?? oe(pe(() => _.scrollTargetId ?? "")), xe = w(), X = u(() => c(_.breadcrumb) || `~anonymous-${xe}`), Z = u(() => _.noncollapsible || Y.isExpanded(X.value, {
			cyclic: U.value,
			defaultOpen: ve.value
		})), Q = u(() => !_.additionalProperties || Z.value), Se = w(), $ = w(), Ce = () => {
			_.noncollapsible || Y.setExpanded(X.value, !Z.value);
		};
		return (e, t) => B.value && Object.keys(B.value).length ? (b(), p("div", {
			key: 0,
			class: y(["schema-card", [
				`schema-card--level-${_.level}`,
				{
					"schema-card--compact": _.compact,
					"schema-card--open": Z.value
				},
				{ "additional-card--tree": _.additionalProperties },
				"schema-card--tree",
				{ "schema-tree [--schema-glyph-background:var(--scalar-background-1)] [--schema-glyph-color:var(--scalar-color-2)]": J.value }
			]]),
			onKeydown: be
		}, [
			C(i)(B.value) ? (b(), d(ee, {
				key: 0,
				class: "my-2",
				value: B.value.externalDocs
			}, null, 8, ["value"])) : f("", !0),
			G.value ? (b(), p("div", k, [g(C(D), { value: G.value }, null, 8, ["value"])])) : f("", !0),
			C(a)(B.value) ? (b(), p("div", A, S(C(F)("schema.emptyObject")), 1)) : f("", !0),
			m("div", { class: y(["schema-properties", [{ "schema-properties-open": Z.value }, "w-full! rounded-none! border-0! [.schema-card--level-0:nth-of-type(1)>.schema-card-description+&]:mt-0! [.schema-card-description+&]:mt-1.5!"]]) }, [_.additionalProperties ? T((b(), p("div", j, [m("button", {
				id: C(Se),
				"aria-controls": Q.value ? C($) : void 0,
				"aria-expanded": Z.value,
				class: "schema-card-title schema-card-title--compact group/tree-control additional-toggle--tree font-code text-c-1! relative flex h-auto min-h-8 items-center gap-0! px-0! py-[var(--schema-row-pad,6px)]! text-sm! font-bold!",
				type: "button",
				onClick: Ce
			}, [g(le, { class: "additional-toggle-glyph" }), m("span", N, [h(S(I.value) + " ", 1), _.name ? (b(), d(n, { key: 0 }, {
				default: he(() => [h(S(C(F)("schema.forName", { name: _.name })), 1)]),
				_: 1
			})) : f("", !0)])], 8, M)], 512)), [[me, !Z.value]]) : f("", !0), Q.value ? (b(), p("ul", {
				key: 1,
				id: C($),
				role: ye.value ? "list" : "presentation"
			}, [K.value ? (b(), d(ue, {
				key: 0,
				breadcrumb: _.breadcrumb,
				compact: _.compact,
				composition: "oneOf",
				compositionPath: _.compositionPath,
				depth: _.depth,
				discriminator: z.value?.discriminator,
				eventBus: _.eventBus,
				expansion: C(Y),
				hideHeading: _.hideHeading,
				hideModelNames: L.value,
				level: _.level,
				name: _.name,
				options: _.options,
				schema: K.value,
				schemaContext: _.schemaContext,
				scrollTargetId: _.scrollTargetId,
				specificationExtension: _.specificationExtension
			}, null, 8, [
				"breadcrumb",
				"compact",
				"compositionPath",
				"depth",
				"discriminator",
				"eventBus",
				"expansion",
				"hideHeading",
				"hideModelNames",
				"level",
				"name",
				"options",
				"schema",
				"schemaContext",
				"scrollTargetId",
				"specificationExtension"
			])) : C(i)(B.value) ? (b(), d(fe, {
				key: 1,
				breadcrumb: _.breadcrumb,
				compact: _.compact,
				compositionPath: _.compositionPath,
				depth: _.depth,
				discriminator: _.discriminator ?? B.value?.discriminator,
				eventBus: _.eventBus,
				expansion: C(Y),
				hideHeading: _.hideHeading,
				hideModelNames: L.value,
				level: _.level + 1,
				options: _.options,
				schema: B.value,
				schemaContext: _.schemaContext,
				scrollTargetId: _.scrollTargetId,
				specificationExtension: _.specificationExtension
			}, null, 8, [
				"breadcrumb",
				"compact",
				"compositionPath",
				"depth",
				"discriminator",
				"eventBus",
				"expansion",
				"hideHeading",
				"hideModelNames",
				"level",
				"options",
				"schema",
				"schemaContext",
				"scrollTargetId",
				"specificationExtension"
			])) : (b(), p(l, { key: 2 }, [B.value ? (b(), d(de, {
				key: 0,
				breadcrumb: _.breadcrumb,
				compact: _.compact,
				compositionPath: _.compositionPath,
				depth: _.depth,
				discriminator: _.discriminator,
				eventBus: _.eventBus,
				expansion: C(Y),
				hideHeading: _.hideHeading,
				hideModelNames: L.value,
				level: _.level,
				options: _.options,
				schema: B.value,
				schemaContext: _.schemaContext,
				scrollTargetId: _.scrollTargetId,
				specificationExtension: _.specificationExtension
			}, null, 8, [
				"breadcrumb",
				"compact",
				"compositionPath",
				"depth",
				"discriminator",
				"eventBus",
				"expansion",
				"hideHeading",
				"hideModelNames",
				"level",
				"options",
				"schema",
				"schemaContext",
				"scrollTargetId",
				"specificationExtension"
			])) : f("", !0)], 64))], 8, P)) : f("", !0)], 2)
		], 34)) : f("", !0);
	}
});
//#endregion
export { F as default };

//# sourceMappingURL=Schema.vue_vue_type_script_setup_true_lang.js.map